export default {
    /**
     * https://stackoverflow.com/questions/31088264/how-to-calculate-excel-pmt-using-php?rq=1
     * Regelmäßige Zahlung. Die konstante Annuität, die in jeder Periode gezahlt wird.
     * @param rate is interest rate
     * @param nper is number of periods
     * @param fv is future value
     * @param pv is present value
     * @param type is type
     * @returns
     */
    rmz(rate = 0, nper = 0, pv = 0, fv = 0, type = 0) {
        return (
            (-fv - pv * Math.pow(1 + rate, nper)) /
            (1 + rate * type) /
            ((Math.pow(1 + rate, nper) - 1) / rate)
        );
    },

    /**
     * FV
     *
     * Returns the Future Value of a cash flow with constant payments and interest rate (annuities).
     * http://www.office-loesung.de/ftopic32346_0_0_asc.php
     * @param   float   rate   Interest rate per period
     * @param   int     nper   Number of periods
     * @param   float   pmt    Periodic payment (annuity)
     * @param   float   pv     Present Value
     * @param   int     type   Payment type: 0 = at the end of each period, 1 = at the beginning of each period
     * @return  float
     */
    zw(rate = 0, nper = 0, pmt = 0, pv = 0, type = 0) {
        // Validate parameters
        if (type != 0 && type != 1) {
            return false;
        }

        // Calculate
        if (rate != 0.0) {
            return (
                -pv * Math.pow(1 + rate, nper) -
                (pmt * (1 + rate * type) * (Math.pow(1 + rate, nper) - 1)) /
                    rate
            );
        } else {
            return -pv - pmt * nper;
        }
    },

    /*!
     * @fileOverview Finance Excel Rate Formula Javascript Equivalent
     * @version 1.0.0
     *
     * @author Burak Arslan @kucukharf http://www.github.com/kucukharf
     * @license
     * Copyright (c) 2010-2018 Burak Arslan
     * Licensed under Creative Commons (CC) license
     * @usage RATE($periods, $payment, $present, $future, $type, $guess)
     */

    zins(periods, payment, present, future, type, guess) {
        guess = guess === undefined ? 0.01 : guess;
        future = future === undefined ? 0 : future;
        type = type === undefined ? 0 : type;

        // Set maximum epsilon for end of iteration
        var epsMax = 1e-10;

        // Set maximum number of iterations
        var iterMax = 10;

        // Implement Newton's method
        var y,
            y0,
            y1,
            x0,
            x1 = 0,
            f = 0,
            i = 0;
        var rate = guess;
        if (Math.abs(rate) < epsMax) {
            y =
                present * (1 + periods * rate) +
                payment * (1 + rate * type) * periods +
                future;
        } else {
            f = Math.exp(periods * Math.log(1 + rate));
            y = present * f + payment * (1 / rate + type) * (f - 1) + future;
        }
        y0 = present + payment * periods + future;
        y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
        i = x0 = 0;
        x1 = rate;
        while (Math.abs(y0 - y1) > epsMax && i < iterMax) {
            rate = (y1 * x0 - y0 * x1) / (y1 - y0);
            x0 = x1;
            x1 = rate;
            if (Math.abs(rate) < epsMax) {
                y =
                    present * (1 + periods * rate) +
                    payment * (1 + rate * type) * periods +
                    future;
            } else {
                f = Math.exp(periods * Math.log(1 + rate));
                y =
                    present * f +
                    payment * (1 / rate + type) * (f - 1) +
                    future;
            }
            y0 = y1;
            y1 = y;
            ++i;
        }
        return rate;
    }
};
